import { waitForAnimations } from "../utils/animation.js";

export type TwoStageActivator = {
  /**
 *
 *
 */
  active: boolean;
  /**
 *
 *
 *
 *
 */
  ready: boolean;
  /**
 *
 *
 */
  done: boolean;
  /**
 *
 */
  on(): void;
  /**
 *
 */
  off(): void;
  /**
 *
 *
 */
  set(active: boolean): void;
};

export type TwoStageActivatorOptions = {
  animated?: () => Element[] | HTMLCollection | null | undefined;
  getAnimationsOptions?: Parameters<HTMLElement["getAnimations"]>[0];
  timeout?: number;
};

const waitForSelectedWaitMethod = async (options: TwoStageActivatorOptions): Promise<unknown> => {
  const elements = Array.from(options.animated?.() || []).filter(Boolean);

  /*                       */
  if (options.timeout || !elements.length) {
    return new Promise((resolve) => setTimeout(resolve, options.timeout));
  } else {
    return waitForAnimations(elements, options.getAnimationsOptions);
  }
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const useTwoStageActivator = (options: TwoStageActivatorOptions = {}): TwoStageActivator => {
  const state = $state({
    active: false,
    ready: false,
    done: false,
    on() {
      /*                        */
      /*                                                 */
      /*                                                             */
      /*                                                                 */
      state.active = true;
      requestAnimationFrame(async () => {
        state.ready = true;
        await waitForSelectedWaitMethod(options);
        state.done = true;
      });
    },
    off() {
      /*                         */
      /*                                                      */
      /*                                                            */
      /*                                                                                         */
      state.done = false;
      state.ready = false;
      requestAnimationFrame(async () => {
        await waitForSelectedWaitMethod(options);
        state.active = false;
      });
    },
    set(active: boolean) {
      if (active === state.active) return;
      (active ? state.on : state.off)();
    },
  });
  return state;
};
